import moment from 'moment';
import _this from '../main';
import Rest from './Rest';
import { localStorage, utils } from '../util/index';

const SLSAPIVersion = '0.6.0';
const defaultUploadLogInterval = 5000;
const SLSEventUrl = process.env.VUE_APP_SLS_URL;

export const SLSEvent = {
  partner_login: '合作方访问b端',
};

export default class Events {
  static eventsQueue = []

  static slsEventReport = async (event, data = {}) => {
    for (const key of Object.keys(data)) {
      data[key] = data[key] !== undefined ? `${data[key]}` : '';
    }

    const { appId, user, openId } = _this.globalData;
    const channel = user ? user.channel : '';
    const unionId = user ? user.unionId : (openId || '');

    const params = {
      event: SLSEvent[event],
      channel,
      openid: unionId,
      apptype: 'h5',
      appid: appId || '',
      eventtime: `${moment().format('YYYYMMDDHHmmss')}`,
      properties: JSON.stringify(data),
      appversion: JSON.stringify(utils.formatQuery(utils.formatQueryString(window.location.href))),
      APIVersion: SLSAPIVersion,
    };

    // Events._save(params, SLSEventUrl);
    // Events.eventsQueue.push(params);
    Events._report(params);
  }

  static _save = (data, url) => {
    const time = moment().format('YYYYMMDDHHmmss');
    const rand = parseInt(Math.random() * 99999, 10);
    localStorage.setObject(`logs-${time}-${rand}`, { data, url });
  }

  static _report = params => Rest.get(SLSEventUrl, { params })

  static uploadLogs = () => {
    try {
      if (Events.uploadingLogs) {
        return;
      }
      Events.uploadingLogs = true;
      const events = Events.eventsQueue;
      Events.eventsQueue = [];

      if (!events.length) {
        Events.uploadingLogs = false;
        return;
      }

      events.forEach(async (event) => {
        await Events._report(event);
      });
    } catch (ex) {
      // nothing
    } finally {
      Events.uploadingLogs = false;
    }
  }
}

// 5 秒钟检查一下是否有本地 logs 没有上传,如果有就上传前 10 个
// setInterval(Events.uploadLogs, defaultUploadLogInterval);
